import { apiRequest } from 'api/apiClient';

const fetchBrand = async (uid) => {
  const response = await apiRequest('GET', `/v1/brands/${uid}`, null);
  return response;
};

const BRAND_QUERIES = {
  FETCH_BRAND: fetchBrand,
};

export default BRAND_QUERIES;
